import * as R from 'ramda';
const getColNameAt = (c, i) => (Array.isArray(c.name) ? c.name[i] : c.name);
export default (columns, headerRows) => {
    return R.map(headerRowIndex => columns.map(c => R.isNil(c.name) && headerRowIndex === headerRows - 1
        ? c.id
        : getColNameAt(c, headerRowIndex)), R.range(0, headerRows));
};
